import { Button, type ColorlessIconProps, IconOzon } from '@direct-frontend/components';
import { Alert, type AlertProps } from '@/shared/components/Alert';
import { DrawerBottomFixed } from '@/shared/components/Drawer';

interface OzonRegistrationModalProps extends AlertProps {
    onSubmit: VoidFunction;
}

export const OzonRegistrationModal = (props: OzonRegistrationModalProps) => {
    const { onSubmit, ...other } = props;

    return (
        <Alert
            {...other}
            title="Доставка через Ozon"
            description="Для оформления и получения нужен аккаунт Ozon. Регистрация займёт пару минут — после неё вы сможете вернуться и завершить покупку."
            button={
                <DrawerBottomFixed>
                    <Button
                        size="m"
                        color="normal"
                        iconLeft={(props: ColorlessIconProps) => <IconOzon {...props} size="24" />}
                        onClick={() => {
                            onSubmit();
                            props.onClose?.();
                        }}
                    >
                        Зарегистрироваться в Ozon ID
                    </Button>
                </DrawerBottomFixed>
            }
        />
    );
};
